import ApplicationConfiguration from "../../../components/ApplicationConfiguration/ApplicationConfiguration";

const ApplicationConfigurationPage = () => {
    return (
        <ApplicationConfiguration></ApplicationConfiguration>
    );
}

export default ApplicationConfigurationPage;
